import type { InferResponseType } from 'hono/client'

import { useApi } from '~/composables/useApi'

type Client = ReturnType<typeof useApi>['client']

export type MfaInfo = InferResponseType<Client['mfaInfo']['$get'], 200>
export type ExtendedUserAccountSession = NonNullable<MfaInfo['extendedUserAccountSession']>
export type PendingUser = NonNullable<MfaInfo['pendingUser']>

/**
 * 認証フローに必要な情報をまとめて取得する（AAL1の状態でも取得可能）
 * - セッション情報（AAL状態）
 * - 組織のMFA設定
 * - 初期設定未実施ユーザー情報
 *
 * 本来はリソースごとに分かれているのが素直だが、ログイン直後に3回リクエストを
 * 往復させると体感が悪いためサーバ側で1つにまとめている
 */
export const getMfaInfo = async (): Promise<MfaInfo> => {
  const { client } = useApi()
  // セッションはサーバがアクセストークンから解決するため、引数で渡さない
  const response = await client.mfaInfo.$get()

  if (!response.ok) {
    throw new Error(`Failed to get MFA info: ${response.status} ${response.statusText}`)
  }

  return await response.json()
}
